<template>
    <div >

   
    <div  class="weui-cell" style="border-bottom: 1px solid rgba(0,0,0,0.1);"> 
        <div class="cell-hd" style="width:120px;padding-bottom: 5px;">
            
            <font style="color: red;" v-if="tb.ismust">*</font>
            <font>{{tb.name}} </font>             

        </div>       
        <div @click="picker" :style="{color:tb.val?'black':'rgb(161, 157, 157)'}" style="color:rgb(161, 157, 157);padding-bottom: 5px;" class="cell-bd" >
            {{tb.val?tb.val:'请选择'+tb.name}}   
        </div>
        <a v-if="tb.val" @click="tb.val=''" style="position: absolute;right: 0;"><i class="weui-icon-clear"></i></a> 
    </div>

</div>
</template>


<script>
export default{
    props:['tb'],
    methods:{
    picker(){
        let newdate = new Date()
 
     let ddate =  [newdate.getFullYear(),newdate.getMonth()+1,newdate.getDate()]
        weui.datePicker({
			     start: this.tb.datefrom,
			     end: this.tb.dateto,
			     defaultValue:ddate ,
			     onChange: function(result){
			         
			     },
			     onConfirm: (result)=>{
                     this.tb.val=result[0].label+result[1].label+result[2].label;
			        
			     },
			     id: 'datePickerddd'
			 });
    }
}
}
</script>


<style>
    .cell-hd{
 padding-top: 16px;
  display: flex;
  align-items: center;
 width:100px; 
    }
    .cell-bd{
  padding-top: 16px;
  display: flex;
  align-items: center;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;

    }

</style>


// WEBPACK FOOTER //
// src/fields/DatePicker.vue